import { ApolloQueryResult } from '@apollo/client'
import { ServiceDependencies } from 'lib/core/services/magento'
import { apolloClient } from 'lib/core/services/magento/client'
import gql from 'graphql-tag'
import { jsonToGraphQLQuery } from 'lib/core/resources/helpers/jsonToGraphql'

export interface GetCheckoutConfigQueryObject {
  getCheckoutConfig: {
    __args: {
      cart_id: string
      [key: string]: any
    }
    payment: {
      code: boolean
      payment_information: boolean
      [key: string]: any
    }
    [key: string]: any
  }
}

export const getCheckoutConfigQueryObject: GetCheckoutConfigQueryObject = {
  getCheckoutConfig: {
    __args: {
      cart_id: ''
    },
    payment: {
      code: true,
      payment_information: true
    }
  }
}

interface GetCheckoutConfigQueryInput {
  cartId: string
}

export type GetCheckoutConfigQuery = (input: GetCheckoutConfigQueryInput) => Promise<ApolloQueryResult<any>>

export const createGetCheckoutConfigQuery = ({ getQueries }: ServiceDependencies): GetCheckoutConfigQuery => async ({ cartId }) => {
  const query = getQueries().getCheckoutConfigQuery
  query.getCheckoutConfig.__args.cart_id = cartId

  return apolloClient.query({ query: gql`${jsonToGraphQLQuery(query)}`, errorPolicy: 'ignore' })
}
